const getDefaultState = () => {
  return {
    app_key: '',
    ciphertext: '',
    huke_token: '',
    huke_org_id: '',
    huke_roles: null,
    huke_org: null,
    huke_profile_id: '',
    huke_profile: null
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_APP_KEY (state, payload) {
    state.app_key = payload || ''
  },

  SET_CIPHERTEXT (state, payload) {
    state.ciphertext = payload || ''
  },

  SET_HUKE_TOKEN (state, payload) {
    console.log(payload, 'payload SET_HUKE_TOKEN')
    state.huke_token = payload
  },

  SET_HUKE_ORG_ID (state, payload) {
    state.huke_org_id = payload
  },

  SET_HUKE_ROLES (state, payload) {
    state.huke_roles = payload
  },

  SET_HUKE_ORG (state, payload) {
    state.huke_org = payload
  },

  SET_HUKE_PROFILE_ID (state, payload) {
    state.huke_profile_id = payload
  },

  SET_HUKE_PROFILE (state, payload) {
    state.huke_profile = payload
  }
}

const actions = {
  changeAppKey ({ commit }, key) {
    commit('SET_APP_KEY', key)
  },

  changeCiphertext ({ commit }, ciphertext) {
    commit('SET_CIPHERTEXT', ciphertext)
  },

  changeHukeToken ({ commit }, token) {
    commit('SET_HUKE_TOKEN', token)
  },

  changeHukeOrgid ({ commit }, org_id) {
    commit('SET_HUKE_ORG_ID', org_id)
  },

  changeHukeRoles ({ commit }, roles) {
    commit('SET_HUKE_ROLES', roles)
  },

  chnageHukeOrg ({ commit }, org) {
    commit('SET_HUKE_ORG', org)
  },

  changeHukeProfileId ({ commit }, profileId) {
    commit('SET_HUKE_PROFILE_ID', profileId)
  },

  changeHukeProfile ({ commit }, profile) {
    commit('SET_HUKE_PROFILE', profile)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
